module.exports = __webpack_public_path__ + "media/Video 84.894686f7.mp4";